import React, {useState} from 'react';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import PropTypes from 'prop-types';
import {Box} from "reflexbox";
import SkeletonImage from "../common/SkeletonImage";
import Typography from "@mui/material/Typography";
import LocationHeader from "../LocationHeader";
import AccordionSummary from "@mui/material/AccordionSummary";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import {KeyboardArrowDown} from '@mui/icons-material';

const CardContainer = (props) => {

  const [openAccordion, setOpenAccordion] = useState(props.answeredIncorrect || false);

  return (
    <>
      <Box mb={3} mt={2}>
        <Card elevation={3}>
          {props.alternateHeader || <LocationHeader {...props} />}
          {/*special answer info*/}
          {props.answerInfo && <Accordion expanded={openAccordion} onChange={() => setOpenAccordion(!openAccordion)} style={{marginBottom: '8px'}}>
            <AccordionSummary expandIcon={<KeyboardArrowDown /> }><span style={{fontWeight: 'bold', fontStyle: 'italic', color: 'gray'}}>Where to find the answer</span></AccordionSummary>
            <AccordionDetails style={{display: 'flex', flexDirection: 'column'}}>
              {props.answerInfo.image1 && <SkeletonImage id={'image2'} src={props.answerInfo.image1} alt={null}/>}
              {props.answerInfo.image1Caption && <CardContent id={'image3-caption'} style={{paddingTop: '4px', paddingBottom: 0}}><Typography component="div"  variant={'caption'}>{props.answerInfo.image1Caption}</Typography></CardContent>}
              {props.answerInfo.content1 && <CardContent id={'content1'} style={{padding: '16px'}}><Typography component="div" >{props.answerInfo.content1}</Typography></CardContent>}
              {props.answerInfo.image2 && <SkeletonImage id={'image2'} src={props.answerInfo.image2} alt={null}/>}
              {props.answerInfo.image2Caption && <CardContent id={'image3-caption'} style={{paddingTop: '4px', paddingBottom: 0}}><Typography component="div"  variant={'caption'}>{props.answerInfo.image2Caption}</Typography></CardContent>}
              {props.answerInfo.content2 && <CardContent id={'content1'} style={{padding: '16px'}}><Typography component="div" >{props.answerInfo.content2}</Typography></CardContent>}
            </AccordionDetails>
          </Accordion>}
          {/*content one*/}
          {props.cardMediaImg && <SkeletonImage greenOverlay={props.locationDone} greenBorder={props.locationDone} id={'image1'} src={props.cardMediaImg} alt={null}/>}
          {props.heading && <CardContent style={{padding: '16px 16px 0 16px'}}><Typography component="div" variant="h6" style={{fontWeight: 'bold'}}>{props.heading}</Typography></CardContent>}
          {props.cardMediaImg1Caption&& <CardContent id={'image3-caption'} style={{paddingTop: '4px', paddingBottom: 0}}><Typography component="div" variant={'caption'}>{props.cardMediaImg1Caption}</Typography></CardContent>}
          {props.cardContent1 && <CardContent id={'content1'} style={{padding: '16px'}}><Typography component="div" >{props.cardContent1}</Typography></CardContent>}
          {/*content two*/}
          {props.cardMediaImg2 && <SkeletonImage id={'image2'} src={props.cardMediaImg2} alt={null}/>}
          {props.cardMediaImg2Caption&& <CardContent id={'image3-caption'} style={{paddingTop: '4px', paddingBottom: 0}}><Typography component="div"  variant={'caption'}>{props.cardMediaImg2Caption}</Typography></CardContent>}
          {props.cardContent2 && <CardContent id={'content2'} style={{padding: '16px'}}><Typography component="div" >{props.cardContent2}</Typography></CardContent>}
          {/*content three*/}
          {props.cardMediaImg3 && <SkeletonImage id={'image3'} src={props.cardMediaImg3} alt={null}/>}
          {props.cardMediaImg3Caption&& <CardContent id={'image3-caption'} style={{paddingTop: '4px', paddingBottom: 0}}><Typography component="div"  variant={'caption'}>{props.cardMediaImg3Caption}</Typography></CardContent>}
          {props.cardContent3 && <CardContent id={'content3'} style={{padding: '16px'}}><Typography component="div" >{props.cardContent3}</Typography></CardContent>}
          {/*other*/}
          {props?.map }
          {props.captionContent && <CardContent><Typography component="div"  > {props.captionContent} </Typography></CardContent>}
          {props.actionsComponent && <div style={{padding: '0 16px 16px 16px'}}>{props.actionsComponent}</div>}
        </Card>
        {!props.noBottomSpacer && <div id={'bottom-spacer'} style={{height: '20px'}} />}
      </Box>
    </>
  )
};

CardContainer.propTypes = {
  location: PropTypes.object,
  alternateHeader: PropTypes.any,
  additionalTitle: PropTypes.any,
  subheader: PropTypes.string,
  cardMediaImg: PropTypes.string,
  cardContent1: PropTypes.any,
  cardMediaImg2: PropTypes.string,
  cardContent2: PropTypes.elementType,
  cardMediaImg3: PropTypes.string,
  cardMediaImg3Caption: PropTypes.string,
  cardContent3: PropTypes.elementType,
  actionsComponent: PropTypes.any,
  locationDone: PropTypes.bool,
};

export default CardContainer;
